// src/sim/systems.ts — Gerçek sim sistemlerinin KANONİK bağlanması (ARCHITECTURE §12 WP9).
// NEDEN ayrı dosya: `world.ts` hiçbir paket dosyasını import etmez (sistemleri enjeksiyonla alır), ama birinin bu
// sekizliyi bir kez bağlaması gerekir. Bağlama `game.ts`teydi; `game.ts` three + Vite `?url` taşıdığı için testler
// (`test/bot.test.ts`) aynı kümeyi elle ikinci kez yazmak zorunda kaldı ve iki kopya sessizce ayrışabiliyordu.
// Ağ otoritesi (headless Node sunucusu) ÜÇÜNCÜ kopyayı yazmak zorunda kalmasın diye bağlama buraya taşındı:
// bu dosya three'siz, DOM'suz ve Vite'siz — `tsx` ile düz Node'da import edilir (NETWORK.md §3).
// Emsal: `frameLoop.ts` aynı gerekçeyle `game.ts`ten ayrılmıştı.
import type { SimSystems } from '../core/types.ts';
import { stepMoves } from './moves.ts';
import { stepGrab } from './grab.ts';
import { applyKnockback, resolveHits } from './hits.ts';
import { stepKnockdown } from './knockdown.ts';
import { tryBlock } from './block.ts';
import { tryDodge } from './dodge.ts';
import { hitboxWorld } from './hitbox.ts';
import { ITEMS_API } from './items.ts';

/** Gerçek sistemler: sim'i koşturan herkes (oyun, testler, ağ sunucusu) BU fonksiyonu çağırır. */
export function realSystems(): SimSystems {
  return { stepMoves, stepGrab, resolveHits, stepKnockdown, tryDodge, tryBlock, applyKnockback, hitboxWorld, items: ITEMS_API };
}
